import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROLE_SI_ADMIN, useAuth } from '@/contexts/AuthContext';
import { SI_PORTAL_BASE_PATH } from '../siPortal.definitions';
import { useSiPortalTabs } from './useSiPortalTabs';

/** Última aba do portal, por pessoa — só pra quem é do SI (os demais sempre voltam no Início). */
const chave = (email: string | null | undefined) => `si-portal-ultima-aba:${email ?? 'anon'}`;

/** Aba (com a busca/filtros da URL) a partir do caminho; telas internas contam como a aba delas. */
function abaDoCaminho(pathname: string): string | null {
  const [, base, segmento] = pathname.split('/');
  if (`/${base}` !== SI_PORTAL_BASE_PATH || !segmento) return null;
  return segmento;
}

/** Grava a aba atual (quem é do SI). Usado no layout do portal. */
export function useGuardarUltimaAbaSi() {
  const { user, userHasRole } = useAuth();
  const location = useLocation();
  const ehSi = userHasRole(ROLE_SI_ADMIN);

  useEffect(() => {
    const aba = abaDoCaminho(location.pathname);
    if (!ehSi || !aba) return;
    try {
      localStorage.setItem(chave(user?.email), JSON.stringify({ aba, search: location.search }));
    } catch {
      // sem storage: volta no Início, como os demais
    }
  }, [ehSi, user?.email, location.pathname, location.search]);
}

/** `/si` sem aba: quem é do SI volta na última aba que estava; os demais vão pro Início. */
export function SiPortalIndexRedirect() {
  const { user, userHasRole } = useAuth();
  const tabs = useSiPortalTabs();
  let destino = 'inicio';
  if (userHasRole(ROLE_SI_ADMIN)) {
    try {
      const salvo = JSON.parse(localStorage.getItem(chave(user?.email)) ?? 'null') as { aba?: string; search?: string } | null;
      if (salvo?.aba && tabs.some((tab) => tab.path === salvo.aba)) destino = `${salvo.aba}${salvo.search ?? ''}`;
    } catch {
      // storage indisponível ou valor inválido: Início
    }
  }
  return <Navigate to={destino} replace />;
}
